import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { AppRouter } from '@/routes/AppRouter';
import { useOrgStore } from '@/stores/orgStore';

type User = {
  id: string;
  email: string;
  fullName: string;
  isEmailVerified: boolean;
  isSuperAdmin: boolean;
};

export function ProtectedApp() {
  const loadedUser = useLoaderData() as User | undefined;
  if (process.env.NODE_ENV === 'development') console.log('[ProtectedApp] Rendered with user:', loadedUser?.id);

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'development') console.log('[ProtectedApp] useEffect triggered, loadedUser:', loadedUser?.id);
    if (loadedUser) {
      const current = useAuthStore.getState().user;
      if (process.env.NODE_ENV === 'development') console.log('[ProtectedApp] Current store user:', current?.id);
      if (!current || current.id !== loadedUser.id) {
        if (process.env.NODE_ENV === 'development') console.log('[ProtectedApp] Updating auth store with new user');
        useAuthStore.setState({ user: loadedUser });
      }
      // Note: Org data should be initialized from bootstrap in main.tsx router loader
      // This ensures we don't make redundant API calls
    }
  }, [loadedUser]);

  return <AppRouter />;
}


